import React from 'react';
import PropTypes from 'prop-types';
import startCase from 'lodash/startCase';

import ORTypography from 'components/ORTypography/ORTypography';

const propTypes = {
  features: PropTypes.shape({
    addons: PropTypes.shape({}),
  }).isRequired,
};

const addOnMap = {
  replicasForHa: 'Replicas for HA',
};

export function UnstyledFeaturesList({ features }) {
  if (!Object.prototype.hasOwnProperty.call(features, 'addons')) {
    return null;
  }

  const { addons } = features;

  const addonsList = Object.keys(addons).map((addon) => (
    <li key={addon}>
      <ORTypography variant="subtitle1">
        {addOnMap[addon] ? addOnMap[addon] : startCase(addon)}: {addons[addon].toString()}
      </ORTypography>
    </li>
  ));

  return <React.Fragment>{addonsList}</React.Fragment>;
}

UnstyledFeaturesList.propTypes = propTypes;

export default UnstyledFeaturesList;
